import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import _ from 'lodash';
import {
    EmvioValidatedInput,
    EmvioValidatedButton,
    EmvioValidatedForm
} from '@nexio/emvio-form-components';
import { getEmail, getUser } from '../Login/loginViewState';
import {
    updatePassword,
    setPassword
} from './updatePasswordActions';
import {
    getIsLoading,
    getIsUpdatePasswordFeedbackSuccessful,
    getUpdatePasswordFeedback,
    getUpdatePasswordFeedbackMessage
} from './updatePasswordViewState';
import { updateEmail } from '../Login/loginActions';
import { withRouter } from 'react-router';
import { historyShape } from '../../utils/propTypes';
import '../Login/Login.scss';

export class UpdatePassword extends Component {
    static propTypes = {
        email: PropTypes.string,
        history: historyShape,
        isFirstLogin: PropTypes.bool,
        isLoading: PropTypes.bool,
        isUpdatePasswordFeedbackSuccessful: PropTypes.bool,
        match: PropTypes.shape({
            params: PropTypes.shape({
                verificationCode: PropTypes.string
            })
        }),
        onSetPassword: PropTypes.func,
        onUpdateEmail: PropTypes.func,
        onUpdatePassword: PropTypes.func,
        updatePasswordFeedback: PropTypes.shape({
            message: PropTypes.string.isRequired
        }),
        updatePasswordFeedbackMessage: PropTypes.string,
        user: PropTypes.shape({
            completeNewPasswordChallenge: PropTypes.func
        })
    };

    state = {
        password: '',
        passwordConfirm: ''
    };

    componentDidMount() {
        if (!this.props.user && this.props.isFirstLogin) {
            this.props.history.push('/');
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.updatePasswordFeedback && prevProps.updatePasswordFeedback !== this.props.updatePasswordFeedback) {
            if (this.props.isUpdatePasswordFeedbackSuccessful) {
                toast(this.props.updatePasswordFeedbackMessage, { type: 'success' });
            } else {
                toast(this.props.updatePasswordFeedbackMessage, { type: 'error' });
            }
        }
    }

    updatePassword = (e) => {
        this.setState({ password: e.target.value });
    };

    updatePasswordConfirm = (e) => {
        this.setState({ passwordConfirm: e.target.value });
    };

    getOnSubmitFunction = () => {
        return this.props.isFirstLogin ?
            this.props.onSetPassword(
                this.props.email,
                this.state.password,
                this.props.history,
                this.props.user
            ) :
            this.props.onUpdatePassword(
                this.props.email,
                this.state.password,
                this.props.match.params.verificationCode,
                this.props.history
            );
    };

    render() {

        return (
            <div className="emvio-login">
                <div className="login-container" >
                    <div className="logo update-password" />
                    <div className="subtitle" id="update-password">
                        Set new password
                    </div>
                    <EmvioValidatedForm className="update-password-form" onSubmit={this.getOnSubmitFunction()}>
                        <div className="login-row">
                            <EmvioValidatedInput
                                autoCapitalize="off"
                                autoComplete="new-password"
                                autoCorrect="off"
                                autoFocus
                                labelText="Email"
                                name="email"
                                onChange={this.props.onUpdateEmail}
                                placeholder="Email Address"
                                shouldEnforceLowerCase={true}
                                type="text"
                                validations={['required', 'email']}
                                value={this.props.email}
                            />
                        </div>
                        <div className="login-row">
                            <EmvioValidatedInput
                                autoComplete="new-password"
                                labelText="New Password"
                                name="password"
                                onChange={this.updatePassword}
                                placeholder="Password"
                                type="password"
                                validations={['required',
                                    'minimumOneNumber',
                                    'minimumOneUpperCase',
                                    'minimumOneLowerCase',
                                    () => {
                                        if (_.get(this.state.password, 'length') < 14) {
                                            return <span className="emvio-form-error">Must be at least 14 characters</span>;
                                        }
                                    },
                                    'passwordMatch'
                                ]}
                                value={this.state.password}
                            />
                        </div>
                        <div className="login-row">
                            <EmvioValidatedInput
                                autoComplete="new-password"
                                labelText="Confirm Password"
                                name="passwordConfirm"
                                onChange={this.updatePasswordConfirm}
                                placeholder="Confirm Password"
                                type="password"
                                validations={['required', 'passwordMatch']}
                                value={this.state.passwordConfirm}
                            />
                        </div>
                        <EmvioValidatedButton isLoading={this.props.isLoading}>
                            SET PASSWORD
                        </EmvioValidatedButton>
                    </EmvioValidatedForm>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        email: getEmail(state),
        isLoading: getIsLoading(state),
        isUpdatePasswordFeedbackSuccessful: getIsUpdatePasswordFeedbackSuccessful(state),
        updatePasswordFeedback: getUpdatePasswordFeedback(state),
        updatePasswordFeedbackMessage: getUpdatePasswordFeedbackMessage(state),
        user: getUser(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onSetPassword: (email, password, history, cognitoUser) =>
            (e) => {
                e.preventDefault();
                setPassword(email, password, dispatch, history, cognitoUser);
            },
        onUpdateEmail: (e) => dispatch(updateEmail(e.target.value)),
        onUpdatePassword: (email, password, verificationCode, history) =>
            (e) => {
                e.preventDefault();
                updatePassword(email, password, verificationCode, dispatch, history);
            }
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UpdatePassword));
